module.exports = __webpack_public_path__ + "img/unit-b.e8436604.svg";